import { Box, Typography } from '@mui/material';
import langDictionary from 'app-strings';
import React from 'react';

type Props = {
    firstName: string;
    lastName: string;
    roomNumber: string;
};

export const ResidentDetails = (props: Props) => {
    const { firstName, lastName, roomNumber } = props;

    const { room: roomTxt } = langDictionary.home;

    return (
        <Box
            sx={{
                flexGrow: 1,
            }}
        >
            <Typography
                sx={{
                    textAlign: 'left',
                    fontWeight: 700,
                }}
            >
                {`${firstName} ${lastName}`}
            </Typography>
            <Typography
                sx={{
                    color: 'orange.main',
                    fontWeight: 700,
                }}
            >
                {`${roomTxt} ${roomNumber ?? 'not set'}`}
            </Typography>
        </Box>
    );
};
